export default "__VITE_ASSET__CvxRgV49__"